interface KeyMap {
  [key: string]: string;
}

export const MED_NOTIFICATION_TEXT_JA: KeyMap = {
  urinated: 'でたかもしれません',
  batteryDead: '電池残量が低下しています。残尿測定は充電後に行ってください。',
  batteryAlert: 'DFree機器本体の異常を検知しました',
  connected: 'データ通信が開始されました',
  disconnected: 'データ通信が途切れました',
};

export const MED_NOTIFICATION_TEXT_EN: KeyMap = {
  urinated: '"Check" - May have urinated',
  batteryDead: 'The battery level is low. Please charge the battery before measuring post-void residual.',
  batteryAlert: 'An abnormality has been detected in the DFree device.',
  connected: 'Data communication has started',
  disconnected: 'Data communication was interrupted',
  zeroReset: 'Battery deterioration of the DFree device has been detected.',
};

export const NOTIFICATION_TRANSLATION_KEYS: KeyMap = {
  disconnected: 'dataCommunicationWasInterrupted(urine)',
  connected: 'dataCommunicationHasStarted(urine)',
  urinated: 'check(urine)',
  bigBladder: 'exceededAlmostThreshold',
  gotUp: 'detectedGettingUp',
  resetUrine: 'measurementResumed',
  dfreeDeviceRemoved: 'SensorIsRemoved(urine)',
  zeroReset: 'checkToSeeIfMoreGelIsNeededOrMakeSureTheDeviceIsAttachedToSkin',
  upsideDown: 'TheSensorIsUpsideDown(urine)',
  batteryAlert: 'anAbnormalityHasBeenDetectedInTheDFreeDeviceItself',
  batteryDead: 'sensorBatteryIsLow(urine)',
  gasPooped: 'odorDetected(stool)',
  gasGotUp: 'detectedGettingUp(stool)',
  gasBatteryDead: 'batteryIsLow(stool)',
  gasBatteryAlert: 'anErrorWasDetectedInDFreeBen',
  gasDisconnected: 'dataCommunicationHasBeenInterrupted(stool)',
  gasConnected: 'dataCommunicationHasStarted(stool)',
  gasPrediction: 'predictedDefecationTime',
  moveUpperAdvice: 'raiseTheSensorPosition',
  moveLowerAdvice: 'lowerTheSensorPosition',
};

export const MED_NOTIFICATION_TRANSLATION_KEYS: KeyMap = {
  bigBladder: 'exceededAlmostThreshold',
  gotUp: 'detectedGettingUp',
  resetUrine: 'MeasurementHasRestarted',
  dfreeDeviceRemoved: 'DFreeMayNotBeAttached',
  upsideDown: 'DFreeMayBeUpsideDown',
};

export const NOTIFICATION_ICON_PATH: KeyMap = {
  disconnected: '/images/notification/icon_disconnected.svg',
  connected: '/images/notification/icon_connected.svg',
  urinated: '/images/notification/icon_urinated.svg',
  bigBladder: '/images/notification/icon_bigbladder.svg',
  gotUp: '/images/notification/icon_gotUp.svg',
  resetUrine: '/images/notification/icon_alert.svg',
  dfreeDeviceRemoved: '/images/notification/icon_alert.svg',
  zeroReset: '/images/notification/icon_alert.svg',
  upsideDown: '/images/notification/icon_alert.svg',
  batteryAlert: '/images/notification/icon_alert.svg',
  batteryDead: '/images/notification/icon_batteryDead.svg',
  gasPooped: '/images/notification/icon_pooped.svg',
  gasGotUp: '/images/notification/icon_gotUp.svg',
  gasBatteryDead: '/images/notification/icon_batteryDead.svg',
  gasBatteryAlert: '/images/notification/icon_alert.svg',
  gasDisconnected: '/images/notification/icon_disconnected.svg',
  gasConnected: '/images/notification/icon_connected.svg',
  gasPrediction: '/images/notification/icon_prediction.svg',
  moveUpperAdvice: '/images/notification/icon_alert.svg',
  moveLowerAdvice: '/images/notification/icon_alert.svg',
  default: '/images/notification/icon_alert.svg',
};

export const NOTIFICATION_TYPE: KeyMap = {
  bigBladder: 'そろそろ',
  urinated: '出たかも',
  batteryDead: '電池切れ',
  dfreeDeviceRemoved: '外れた',
  gotUp: '起き上がり',
  resetUrine: 'リセット',
  zeroReset: 'ゼロリセット',
  upsideDown: '上下逆',
};

export const NOTIFICATION_NAME_VALUES = [
  {
    value: 'bigBladder',
    label: 'そろそろ',
  },
  {
    value: 'urinated',
    label: '出たかも',
  },
  {
    value: 'batteryDead',
    label: '電池切れ',
  },
  {
    value: 'dfreeDeviceRemoved',
    label: '外れた',
  },
  {
    value: 'gotUp',
    label: '起き上がり',
  },
  {
    value: 'resetUrine',
    label: 'リセット',
  },
  {
    value: 'zeroReset',
    label: 'ゼロリセット',
  },
  {
    value: 'upsideDown',
    label: '上下逆',
  },
];
